import React from 'react';

/** Target / bullseye — matches admin gear stroke style (collapsed Overview). */
export function AiVisOverviewIcon({ className, title }) {
  const sw = 1.65;
  return (
    <svg
      className={className}
      width={22}
      height={22}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={sw} />
      <circle cx={12} cy={12} r={5.5} stroke="currentColor" strokeWidth={sw} />
      <circle cx={12} cy={12} r={2.35} fill="currentColor" />
    </svg>
  );
}

/** Modern rounded gear (inspired by Lucide settings) — outline style for collapsed nav. */
export function AiVisAdminConsoleIcon({ className, title }) {
  return (
    <svg
      className={className}
      width={22}
      height={22}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title ? <title>{title}</title> : null}
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={1.65}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
      />
      <circle cx={12} cy={12} r={3} stroke="currentColor" strokeWidth={1.65} />
    </svg>
  );
}

/** Stroke plus — mathematically centered in 24×24 (avoids text baseline drift). */
export function AiVisPlusIcon() {
  return (
    <svg
      className="aivis-plus-svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M12 5v14M5 12h14"
        stroke="currentColor"
        strokeWidth={2.5}
        strokeLinecap="round"
      />
    </svg>
  );
}

const sw = 1.65;

export function AiVisHomeIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <path
        d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AiVisPromptsIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <path
        d="M7 8h10M7 12h6M7 16h10"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
      />
      <path
        d="M5 4h14a2 2 0 0 1 2 2v14l-4-3H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AiVisDomainsIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={sw} />
      <path
        d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18"
        stroke="currentColor"
        strokeWidth={sw}
      />
    </svg>
  );
}

export function AiVisSourcesIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      {/* Chain / link icon */}
      <path
        d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AiVisBrandsIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      {/* Shield / brand badge icon */}
      <path
        d="M12 2L4 6v6c0 5.25 3.5 9.74 8 11 4.5-1.26 8-5.75 8-11V6L12 2Z"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12l2 2 4-4"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AiVisSettingsNavIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <circle cx={12} cy={12} r={3} stroke="currentColor" strokeWidth={sw} />
      <path
        d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function AiVisCompetitorsIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <path d="M12 3l2.5 5.5L20 9.5l-4 4 1 5.5L12 16l-5 3 1-5.5-4-4 5.5-1L12 3z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

export function AiVisFanOutIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <circle cx={11} cy={11} r={7} stroke="currentColor" strokeWidth="1.6" />
      <line x1="16.5" y1="16.5" x2="21" y2="21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <line x1="11" y1="8" x2="11" y2="14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <line x1="8" y1="11" x2="14" y2="11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function AiVisResponsesIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      {/* scroll / document with a sparkle — represents an AI-generated response */}
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 2v6h6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="8" y1="13" x2="16" y2="13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <line x1="8" y1="17" x2="13" y2="17" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      {/* small spark / star at top-right corner */}
      <path d="M18 3l.5 1.5L20 5l-1.5.5L18 7l-.5-1.5L16 5l1.5-.5Z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
    </svg>
  );
}

export function AiVisSystemOverviewIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <rect x="3" y="3" width="7" height="7" rx="1.2" stroke="currentColor" strokeWidth="1.6" />
      <rect x="14" y="3" width="7" height="7" rx="1.2" stroke="currentColor" strokeWidth="1.6" />
      <rect x="3" y="14" width="7" height="7" rx="1.2" stroke="currentColor" strokeWidth="1.6" />
      <rect x="14" y="14" width="7" height="7" rx="1.2" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

export function AiVisMembersIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <circle cx={9} cy={8} r={3.5} stroke="currentColor" strokeWidth={sw} />
      <path d="M3 20v-1a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v1" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" />
      <path
        d="M17 11a3 3 0 1 0 0-6M21 20v-.5a4 4 0 0 0-4-4h-.5"
        stroke="currentColor"
        strokeWidth={sw}
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Checklist — represents planned/approved content topics. */
export function AiVisContentStrategyIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <rect x="4" y="3" width="16" height="18" rx="2" stroke="currentColor" strokeWidth={sw} />
      <path d="M8 8.5l1.3 1.3L11.5 7.5" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="13.5" y1="8.5" x2="17" y2="8.5" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" />
      <path d="M8 14.5l1.3 1.3L11.5 13.5" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" />
      <line x1="13.5" y1="14.5" x2="17" y2="14.5" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" />
    </svg>
  );
}

/** Funnel / filter — represents enrichment (crawling sources to find mentions). */
export function AiVisEnrichmentIcon({ className, title }) {
  return (
    <svg className={className} width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={!title}>
      {title ? <title>{title}</title> : null}
      <path
        d="M3 4h18l-7 8v6l-4 2v-8L3 4Z"
        stroke="currentColor"
        strokeWidth={1.6}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
